var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 9.99999L0.924638 9.73971L0.716406 9.99999L0.924638 10.2603L1.25 9.99999ZM8.75 10.4167C8.98012 10.4167 9.16667 10.2301 9.16667 9.99999C9.16667 9.76988 8.98012 9.58333 8.75 9.58333V10.4167ZM4.25797 5.57304L0.924638 9.73971L1.57536 10.2603L4.9087 6.09362L4.25797 5.57304ZM0.924638 10.2603L4.25797 14.427L4.9087 13.9064L1.57536 9.73971L0.924638 10.2603ZM1.25 10.4167H8.75V9.58333H1.25V10.4167Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 6.7766V6.15708C8.75 4.80846 8.75 4.13415 9.14497 3.66791C9.53993 3.20167 10.2051 3.09081 11.5353 2.8691L12.928 2.63699C15.6306 2.18656 16.9819 1.96134 17.8659 2.71026C18.75 3.45917 18.75 4.8291 18.75 7.56896V12.431C18.75 15.1709 18.75 16.5408 17.8659 17.2897C16.9819 18.0386 15.6306 17.8134 12.928 17.363L11.5353 17.1309C10.2051 16.9092 9.53993 16.7983 9.14497 16.3321C8.75 15.8658 8.75 15.1915 8.75 13.8429V13.3883",
    stroke: "white",
    strokeWidth: 0.833333
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeave);
export default __webpack_public_path__ + "static/media/leave.d81a20b11db48b6a06a9715628e60dde.svg";
export { ForwardRef as ReactComponent };